// client/src/components/SectionMenu.jsx
import { Box, Typography } from '@mui/material';
import { IconMap } from '../lib/icons'; // adjust path if needed
import RoundedIconTile from './RoundedIconTile';

export default function SectionMenu({ title, items }) {
  return (
    <Box sx={{ pl: 2, pr: 2 }}>
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h6"
          color="accent"
          sx={{
            fontSize: '14px',
            fontWeight: 300,
            textTransform: 'uppercase'
          }}>
          {title}
        </Typography>

        <Typography variant="headingText" sx={{ fontSize: '3.5em' }}>
          How can we help you today?
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2
        }}>
        {items.map((item, index) => {
          const IconComponent = item.icon ? IconMap[item.icon] : null;

          return (
            <RoundedIconTile
              key={index}
              title={item.text}
              secondaryText={item.secondaryText}
              image={item.image}
              icon={IconComponent ? <IconComponent style={{ fontSize: 30 }} /> : null}
              onClick={() => (window.location.href = item.link)}
            />
          );
        })}
      </Box>
    </Box>
  );
}
